module.exports = __webpack_public_path__ + "static/media/Wolves927_4c2.519d3a58.svg";